<template>
  <div class="non-doc-info tw-mt-10 lg:tw-mt-0">
    <template v-if="isOnboardingRedesign">
      <div
        v-if="onboardingVariant === 'F2'"
        class="tw-flex tw-justify-center tw-my-6"
      >
        <svg
          width="60"
          height="74"
          viewBox="0 0 72 89"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36 88.0891C35.6479 88.0891 35.2078 88.0157 34.6797 87.869C34.1809 87.7517 33.6528 87.5463 33.0954 87.2529C26.9633 83.7615 21.7702 80.6808 17.5159 78.0109C13.291 75.3409 9.88753 72.759 7.30562 70.2651C4.75306 67.7419 2.88998 65.028 1.71638 62.1233C0.572127 59.1893 0 55.7419 0 51.781V18.5977C0 16.3385 0.484108 14.7101 1.45232 13.7126C2.42054 12.6857 3.81418 11.8055 5.63325 11.072C6.66015 10.6612 8.06846 10.1184 9.85819 9.44362C11.6479 8.73947 13.6137 7.9913 15.7555 7.19912C17.9266 6.37761 20.0831 5.58543 22.2249 4.8226C24.3961 4.03042 26.3765 3.32626 28.1663 2.71013C29.956 2.06465 31.3643 1.56587 32.3912 1.21379C32.978 1.03775 33.5648 0.891055 34.1516 0.773695C34.7677 0.656336 35.3839 0.597656 36 0.597656C36.6161 0.597656 37.2323 0.656336 37.8484 0.773695C38.4645 0.891055 39.066 1.03775 39.6528 1.21379C40.6797 1.56587 42.0733 2.06465 43.8337 2.71013C45.6235 3.32626 47.5892 4.03042 49.731 4.8226C51.9022 5.61477 54.0587 6.40695 56.2005 7.19912C58.3716 7.9913 60.3521 8.7248 62.1418 9.39961C63.9315 10.0744 65.3399 10.6319 66.3667 11.072C68.2152 11.8348 69.6088 12.715 70.5477 13.7126C71.5159 14.7101 72 16.3385 72 18.5977V51.781C72 55.7419 71.4425 59.2187 70.3276 62.2113C69.2127 65.1747 67.379 67.9473 64.8264 70.5292C62.3032 73.1111 58.9144 75.7224 54.6601 78.3629C50.4352 81.0035 45.1834 83.9669 38.9046 87.2529C38.3472 87.5463 37.8044 87.7517 37.2763 87.869C36.7775 88.0157 36.3521 88.0891 36 88.0891ZM31.1149 64.1918C31.8778 64.1918 32.5672 64.0157 33.1834 63.6637C33.7995 63.3116 34.3423 62.7835 34.8117 62.0793L55.4963 29.4681C55.7604 29.028 56.0098 28.5585 56.2445 28.0598C56.4792 27.561 56.5966 27.0622 56.5966 26.5634C56.5966 25.5365 56.2152 24.7297 55.4523 24.1429C54.6895 23.5268 53.8386 23.2187 52.8998 23.2187C51.6088 23.2187 50.5526 23.8935 49.731 25.2431L30.9389 55.4338L22.0049 43.9033C21.4474 43.1698 20.9046 42.671 20.3765 42.4069C19.8778 42.1429 19.3056 42.0109 18.6601 42.0109C17.6626 42.0109 16.8264 42.3776 16.1516 43.1111C15.4768 43.8153 15.1394 44.6661 15.1394 45.6637C15.1394 46.1624 15.2274 46.6612 15.4034 47.16C15.6088 47.6294 15.8729 48.0842 16.1956 48.5243L27.2421 62.0793C27.8288 62.8422 28.4303 63.3849 29.0465 63.7077C29.6626 64.0304 30.3521 64.1918 31.1149 64.1918Z"
            fill="#AF8EFF"
          />
        </svg>
      </div>

      <DoctorHeader v-if="['E1', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
        Help us verify your identity so your doctor can legally prescribe you medication.
      </DoctorHeader>
      <h1
        v-if="['F3v1', 'F3v2', 'G'].includes(onboardingVariant)"
        class="question-title"
      >
        Help us verify your identity so your doctor can legally prescribe you medication.
      </h1>
      <h1
        v-if="!['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
        class="question-title"
        :class="{'tw-text-center': onboardingVariant === 'F2'}"
      >
        Help us verify your identity so a doctor can legally prescribe you medication.
      </h1>

      <div
        :class="{
          '!tw-mt-[1rem]': ['E1', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant),
          'tw-text-center': onboardingVariant === 'F2'
        }"
      >
        <a
          v-if="onboardingVariant !== 'D1' && onboardingVariant !== 'D2'"
          href="javascript:;"
          class="tw-underline tw-text-lg"
          @click="toggleModal"
        >
          <span v-if="['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">Why does my doctor need to verify my identity?</span>
          <span v-else>Why do you need to verify my identity?</span>
        </a>
      </div>
      <template v-if="onboardingVariant === 'D1' || onboardingVariant === 'D2'">
        <p class="tw-text-[20px] tw-leading-5 md:tw-leading-[26px] md:tw-text-2xl tw-text-[#787878]">
          A medical provider is required to verify your identity before
          prescribing medication. Your personal identifiable information, medical
          history, and/or ID will remain confidential within our secure platform.
        </p>
      </template>
      <template v-if="['D1', 'D2', 'E1', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
        <div class="tw-w-full tw-flex tw-justify-center tw-my-10">
          <OnboardingTLSSecurity />
        </div>
        <div class="tw-w-full tw-flex tw-justify-center tw-my-10">
          <OnboardingCertifiedSeal />
        </div>
      </template>
    </template>
    <template v-else>
      <h1
        style="font-size: 24px; font-weight: 600"
        class="tw-mt-20 md:tw-mt-10"
      >
        Help us verify your identity so a doctor can legally prescribe you medication.
      </h1>
  
      <h3 class="tw-text-lg">
        <a
          href="javascript:;"
          class="tw-underline tw-text-lavender-purple"
          @click="toggleModal"
        >
          Why do you need to verify my identity?
        </a>
      </h3>
    </template>
    
    <modal
      id="nondocinfo"
      v-model="showNonDocModal"
      size="md"
      hide-footer
      hide-header
      centered
      :body-class="{'!tw-p-0': isOnboardingRedesign, '!tw-p-12': !isOnboardingRedesign}"
      :show-close-button="isOnboardingRedesign ? false : true"
    >
      <div
        v-if="isOnboardingRedesign"
      >
        <div class="tw-p-6">
          <h2 class="tw-text-2xl">
            A medical provider is required to verify your identity before prescribing medication. Your personal identifiable information, medical history, and ID will remain confidential within our secure platform.
          </h2>
        </div>
        <div
          class="tw-py-4"
          style="box-shadow: -8px -6px 23.3px 0px rgba(45, 43, 43, 0.05);"
        >
          <b-button
            class="slight-rounded tw-max-w-[300px] tw-mx-auto"
            block
            pill
            variant="info"
            @click="$root.$emit('bv::hide::modal', 'nondocinfo');"
          >
            Close
          </b-button>
        </div>
      </div>
      <div v-else>
        <h2
          class="tw-text-2xl tw-mb-16"
        >
          A medical provider is required to verify your identity before prescribing medication. Your personal identifiable information, medical history, and ID will remain confidential within our secure platform.
        </h2>
        <div>
          <b-button
            class="slight-rounded tw-inline-block"
            block
            pill
            variant="info"
            @click="$root.$emit('bv::hide::modal', 'nondocinfo');"
          >
            Close
          </b-button>
        </div>
      </div>
    </modal>

    <OnboardingCTAContainer>
      <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
        <b-button
          class="slight-rounded"
          :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
          variant="info"
          pill
          block
          @click="next"
        >
          <div
            v-if="onboardingVariant === 'F2'"
            class="tw-flex tw-justify-center tw-items-center tw-gap-2"
          >
            <!-- Lock icon -->
            <svg
              width="12"
              height="16"
              viewBox="0 0 12 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.19141 15.9922C1.56641 15.9922 1.09245 15.8255 0.769531 15.4922C0.451823 15.1641 0.292969 14.6589 0.292969 13.9766V8.17188C0.292969 7.5 0.451823 7 0.769531 6.67188C1.09245 6.33854 1.56641 6.17188 2.19141 6.17188H9.80859C10.4336 6.17188 10.9049 6.33854 11.2227 6.67188C11.5456 7 11.707 7.5 11.707 8.17188V13.9766C11.707 14.6589 11.5456 15.1641 11.2227 15.4922C10.9049 15.8255 10.4336 15.9922 9.80859 15.9922H2.19141ZM2.73828 14.2031H9.26172C9.41797 14.2031 9.53516 14.1589 9.61328 14.0703C9.69141 13.9818 9.73047 13.8516 9.73047 13.6797V8.47656C9.73047 8.29948 9.69141 8.16927 9.61328 8.08594C9.53516 8.0026 9.41797 7.96094 9.26172 7.96094H2.73828C2.58724 7.96094 2.47005 8.0026 2.38672 8.08594C2.30859 8.16927 2.26953 8.29948 2.26953 8.47656V13.6797C2.26953 13.8516 2.30859 13.9818 2.38672 14.0703C2.47005 14.1589 2.58724 14.2031 2.73828 14.2031ZM1.83203 6.92188V4.39844C1.83203 3.46615 2.01953 2.67448 2.39453 2.02344C2.77474 1.36719 3.27995 0.867188 3.91016 0.523438C4.54036 0.179688 5.23568 0.0078125 5.99609 0.0078125C6.76172 0.0078125 7.45964 0.179688 8.08984 0.523438C8.72005 0.867188 9.22266 1.36719 9.59766 2.02344C9.97786 2.67448 10.168 3.46615 10.168 4.39844V6.92188H8.31641V4.30469C8.31641 3.77865 8.21224 3.32812 8.00391 2.95312C7.79557 2.57812 7.51432 2.29167 7.16016 2.09375C6.8112 1.89583 6.42318 1.79688 5.99609 1.79688C5.56901 1.79688 5.18099 1.89583 4.83203 2.09375C4.48307 2.29167 4.20443 2.57812 3.99609 2.95312C3.79297 3.32812 3.69141 3.77865 3.69141 4.30469V6.92188H1.83203Z"
                fill="white"
              />
            </svg>
            Start Verification
          </div>
          <template v-else>
            Continue
          </template>
        </b-button>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { OnboardingService } from '@/services/onboarding.service';

// mixins
import analyticsMixin from '@/mixins/analytics';

import { mapState } from 'vuex';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import OnboardingTLSSecurity from '@/components/onboarding/OnboardingTLSSecurity.vue';
import OnboardingCertifiedSeal from '@/components/onboarding/OnboardingCertifiedSeal.vue';
import DoctorHeader from '@/components/partials/DoctorHeader.vue';

export default {
  components: {
    DoctorHeader,
    OnboardingCertifiedSeal,
    OnboardingTLSSecurity,
    OnboardingCTAContainer,
  },
  mixins: [analyticsMixin],
  props: {
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    analyticsId: {
      type: String,
      default: '',
    },
    firstname: {
      type: String,
      default: '',
    },
    lastname: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showNonDocModal: false,
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
  },
  async mounted() {
    await this.$_analytics_track(
      'Onboarding Screen Viewed',
      {
        customerId: this.analyticsId,
        screen: '4.1-A',
        onboardingflow: this.onboardingflow,
        firstname: this.firstname,
        lastname: this.lastname
      },
    );
    const onboarding = await OnboardingService.getPatientOnboarding();

    try {
      const event_checkoutstarted = await OnboardingService.triggerOnboardingEvents({
        eventname: 'VerificationStarted',
        path: window.location.pathname,
      })
      if (event_checkoutstarted.data.status === 'new') {
        await this.$_analytics_track(
          'Identity Verification Started',
          {
            customerId: this.analyticsId,
            onboardingflow: this.onboardingflow,
            state: this.state,
            phoneno: this.phoneno,
            email: this.email,
            messageID: event_checkoutstarted.data.id,
            firstname: this.firstname,
            lastname: this.lastname,
          },
        );

        if (event_checkoutstarted.data.id) {
          this.fbqTrack(onboarding.data, event_checkoutstarted.data.id);
        } else if (
          event_checkoutstarted.data.id &&
            process.env.VUE_APP_SERVER != 'production'
        ) {
          console.log('FB TRACKING VerificationStarted');
          console.log(
            'FB TRACKING VerificationStarted: ' +
                event_checkoutstarted.data.id
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    next() {
      this.$emit('next');
    },
    toggleModal() {
      this.$root.$emit('bv::show::modal', 'nondocinfo');
    },
    async fbqTrack(data, eventID) {
      // FB Pixel Tracking
      try {
        fbq('init', '348219289912097', {
          em: data.email,
          fn: data.firstname,
          ln: data.lastname,
          ph: data.phoneno,
          external_id: data.id,
          extern_id: data.id,
        });
        // fbq("track", "PageView");
        const pageViewBody = { userid: data.id };
        OnboardingService.onboardingEvent('PageView', pageViewBody);
        fbq(
          'trackCustom',
          'VerificationStarted',
          {
            external_id: data.id,
            extern_id: data.id,
            state: this.state,
            ...(await this.$store.dispatch('getFBQParams')),
          },
          {
            eventID: eventID,
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
  }
}
</script>